import { InfoField } from '@occc-app/design-system';
import { ConstraintFragment } from '@occc/graphql';
import { formatYesNoValues } from '../../formatters';

export const InStoreOnlyConstraint = ({ constraints }: { constraints: ConstraintFragment[] }) => {
  const cst = constraints.filter((c) => c.__typename === 'ConstraintInStoreOnly');

  return (
    <InfoField label='In Store Only' value={cst.length ? formatYesNoValues(cst) : undefined} />
  );
};
